import { Box, Dialog, DialogContent } from '@mui/material';

import { ImageCarousel, type ImageCarouselProps } from '../ImageCarousel/ImageCarousel';

interface Props {
  open: boolean;
  selectedMedium: string;
  onClose: () => void;
  media: string[];
  placeholderSrc?: string;
  handleNavigate?: (src: string) => void;
  slotProps?: {
    imageCarousel: Pick<ImageCarouselProps, 'slotProps'>;
  };
}

export const MediaDialog = (props: Props) => {
  const { onClose, open, media } = props;

  return (
    <Dialog onClose={onClose} open={open} fullWidth data-testid="image-dialog" fullScreen>
      <DialogContent
        sx={{
          p: 0,
        }}
      >
        <Box height="100dvh">
          <ImageCarousel
            photoEvidence={media}
            selectedMedia={props.selectedMedium}
            showActions
            showImageCounter={true}
            showBackButton={true}
            handleBackButtonClick={onClose}
            handleNavigate={props.handleNavigate}
            slotProps={{
              mediaItem: {
                alt: 'Media item',
                objectFit: 'contain',
                placeholderSrc: props.placeholderSrc,
              },
              mediaItemSlot: props.slotProps?.imageCarousel?.slotProps?.mediaItemSlot,
              sidebar: props.slotProps?.imageCarousel?.slotProps?.sidebar,
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
